import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft, Home } from "lucide-react";

export default function BackNav() {
  const navigate = useNavigate();

  const goBack = () => {
    if (window.history.state && window.history.state.idx > 0) {
      navigate(-1);
    } else {
      navigate("/");
    }
  };

  return (
    <div className="flex items-center gap-5" data-testid="back-nav">
      <button
        type="button"
        data-testid="back-btn"
        onClick={goBack}
        className="inline-flex items-center gap-1.5 text-sm font-medium text-muted-soft hover:text-navy transition-colors duration-200"
      >
        <ArrowLeft size={16} /> Indietro
      </button>
      <Link
        to="/"
        data-testid="home-link"
        className="inline-flex items-center gap-1.5 text-sm font-medium text-muted-soft hover:text-navy transition-colors duration-200"
      >
        <Home size={15} /> Home
      </Link>
    </div>
  );
}
